import { Suspense } from 'react'
import { clsx } from 'clsx'
import { observer } from 'mobx-react'

import ErrorBoundaryWithRouter from 'Components/ErrorBoundary/ErrorBoundaryWithRouter'
import { Footer } from 'Components/Footer/Footer'
import { LeftSidebar } from 'Components/LeftSidebar/LeftSidebar'
import { MobileNavigationBar } from 'Components/MobileNavigationBar/MobileNavigationBar'
import { PageLoadingState } from 'Components/PageLoadingState/PageLoadingState'
import { ScrollToTop } from 'Components/ScrollToTop/ScrollToTop'
import { Topbar } from 'Components/Topbar/Topbar'

import { useIsServiceApp } from 'Hooks'

import type { AuthorisedLayoutProps } from './AuthorisedLayout.types'

export const AuthorisedLayout = observer((props: AuthorisedLayoutProps) => {
  const { children } = props
  const isServiceApp = useIsServiceApp()

  return (
    <div>
      <ScrollToTop />

      <Topbar />

      <Suspense fallback={<PageLoadingState />}>
        <LeftSidebar />
      </Suspense>

      <main className={clsx('page', isServiceApp && 'pb-0')}>
        <div className="wrapper">
          <ErrorBoundaryWithRouter>
            {children}

            {!isServiceApp && <Footer />}
          </ErrorBoundaryWithRouter>
        </div>
      </main>

      {isServiceApp && <MobileNavigationBar />}
    </div>
  )
})
